import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { AlterarSenha } from '@/modules/system/auth/application/auth.service';
import { toast } from 'react-toastify';

interface ModalAlterarSenhaProps {
  show: boolean;
  onClose: () => void;
}

const SENHA_MINIMA =
  'A senha precisa ter no mínimo 8 caracteres, 1 maiúsculo, 1 minúsculo e 1 caractere especial.';
const regexSenhaForte = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export function ModalAlterarSenha({ show, onClose }: ModalAlterarSenhaProps) {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [senhaNova, setSenhaNova] = useState('');
  const [senhaNovaConfirma, setSenhaNovaConfirma] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => {
    if (!submitting) {
      setSenhaAtual('');
      setSenhaNova('');
      setSenhaNovaConfirma('');
      onClose();
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!senhaAtual.trim()) {
      toast.error('Informe a senha atual.');
      return;
    }
    if (!senhaNova.trim()) {
      toast.error('Informe a nova senha.');
      return;
    }
    if (!regexSenhaForte.test(senhaNova)) {
      toast.error(SENHA_MINIMA);
      return;
    }
    if (senhaNova !== senhaNovaConfirma) {
      toast.error('A confirmação da nova senha não confere.');
      return;
    }
    setSubmitting(true);
    try {
      await AlterarSenha(senhaAtual, senhaNova);
      toast.success('Senha alterada com sucesso.');
      handleClose();
    } catch (err: unknown) {
      const message = err && typeof err === 'object' && 'message' in err ? String((err as { message: string }).message) : 'Falha ao alterar senha.';
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Alterar senha</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Senha atual</Form.Label>
            <Form.Control
              type="password"
              value={senhaAtual}
              onChange={(e) => setSenhaAtual(e.target.value)}
              autoComplete="current-password"
              placeholder="Digite sua senha atual"
              disabled={submitting}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Nova senha</Form.Label>
            <Form.Control
              type="password"
              value={senhaNova}
              onChange={(e) => setSenhaNova(e.target.value)}
              autoComplete="new-password"
              placeholder="Mín. 8 caracteres, 1 maiúsculo, 1 minúsculo, 1 especial"
              disabled={submitting}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Confirmar nova senha</Form.Label>
            <Form.Control
              type="password"
              value={senhaNovaConfirma}
              onChange={(e) => setSenhaNovaConfirma(e.target.value)}
              autoComplete="new-password"
              placeholder="Repita a nova senha"
              disabled={submitting}
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2">
            <Button variant="outline-secondary" onClick={handleClose} disabled={submitting}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit" disabled={submitting}>
              {submitting ? 'Alterando…' : 'Alterar senha'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
